import { NfcAction } from "./action";
import { NFCState, nfcState } from "./state";

export function NFCReducer(state:NFCState= nfcState,action :NfcAction):NFCState{
    switch(action.type){
        case '@@NfcState/initNFCListAction':
            return {
                ...state,
                nfcList:action.nfcList
            }

            default:
                return state;
    }
}